import reduceReducers from 'reduce-reducers';

import offers, { initialState as offerInitialState } from './reducer';
import { OffersState } from './types';
import newOffer, {
  initialState as newOfferInitialState,
} from './newOffer/reducer';

const initialState: OffersState = {
  ...offerInitialState,
  newOffer: newOfferInitialState,
};

// @ts-ignore `reduceReducers` does not support an `action` generic type,
// so using a reducer function with type `Reducer<OffersState, OfferAction>`
// would throw an error because it expects only the default `AnyAction` type
const offersReducer = reduceReducers(initialState, offers, newOffer);

export default offersReducer;
